import * as React from 'react';
import { Button } from '@/components/atoms/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
} from '@/components/atoms/dialog';
import { TriangleAlert } from 'lucide-react';
import { Loader } from '@/components/molecules/Loader';

type ConfirmationAlertProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  loadingMessage: string;
};

export function ConfirmationAlert(props: ConfirmationAlertProps) {
  const {
    isOpen,
    onOpenChange,
    message,
    onConfirm,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
  } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const confirmationAlertRef = React.useRef<HTMLDivElement>(null);
  const [confirmationAlertHeight, setConfirmationAlertHeight] = React.useState(0);

  const handleConfirm = () => {
    const confirmationAlertHeight = confirmationAlertRef.current?.clientHeight || 0;
    setConfirmationAlertHeight(confirmationAlertHeight);
    setIsLoading(true);
    onConfirm();
    setTimeout(() => {
      setIsLoading(false);
      onOpenChange(false);
    }, 1000);
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
      { !isLoading &&
          <div className="min-h-[218px]" ref={confirmationAlertRef}>
            <DialogDescription>
              <div className="w-full flex justify-center p-8">
                <TriangleAlert size={64} />
              </div>
              <div className="text-center p-4">
                {message}
              </div>
            </DialogDescription>
            <DialogFooter>
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                {cancelText}
              </Button>
              <Button variant="destructive" onClick={handleConfirm}>
                {confirmText}
              </Button>
            </DialogFooter>
          </div>
      }
      {
        isLoading && <Loader height={confirmationAlertHeight} loadingMessage={props.loadingMessage} />
      }
      </DialogContent>
    </Dialog>
  );
} 